export const PERCENT_TO_SNAP_TO = 0.05;
